// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const SeveritySourceSchema = z.enum(['AGENT','USER'] as const);

export type SeveritySourceType = `${z.infer<typeof SeveritySourceSchema>}`

export default SeveritySourceSchema;
